import store from '../store';

export const useDispatch = () => store.dispatch;
